import React from 'react';
import { useDataValue } from 'globals/contexts/dataContext';

import './eventSection.css';
import './eventSectionMobile.css';
import { Link, generatePath } from 'react-router-dom';
import routes from 'globals/routes';

const EventSection = (props) => {
  const pageContent = props['content'];
  const [{currentLanguage}] = useDataValue();
  return <section className="event" id="event">
    <div className="title">{pageContent['title']}</div>
    <div className="eventBox">
      <div className="contentBox">
        <div dangerouslySetInnerHTML={{
          __html: (pageContent['introductions'] && pageContent['introductions']['length'])? pageContent['introductions'][0]['text']: ''
        }} />
        <Link to={generatePath(routes['eventPage'], { lang: currentLanguage, eventname: pageContent['eventtitle']})}><button>{pageContent['buttonText']}</button></Link>
        {/* <a href={pageContent['buttonUrl']} target="_blank"><button>{pageContent['buttonText']}</button></a> */}
      </div>
      <div className="seperator"></div>
      <div className="introductions">
        {pageContent['introductions'].map(content => {
          return <div key={content['language']} 
            className={`introduction verticalText ${content['language']} ${content['language'] === currentLanguage? 'mobile': ''}`}
            dangerouslySetInnerHTML={{
              __html: pageContent['eventtitle']
            }} />;
        })}
      </div>
      <div className="date">
        <div className="month verticalText zh">{pageContent['month'][0]}</div>
        <div className="month verticalText en">{pageContent['month'][1]}</div>
      </div>
    </div>
  </section>;
}

export default EventSection;
    